/* ============================================================================
   Sticky-Leiste auf der Produktseite (Markup: snippets/l4-sticky-atc.liquid)

   - Zwei Stufen, gleiche Messung wie die mobile Konfigurator-Leiste
     (assets/shelf-filter.js): die Leiste mit dem Zurueck-Button erscheint,
     sobald der Zurueck-Link oben (snippets/l4-back-link.liquid) unter den
     Header scrollt; Preis, Anzahl und Warenkorb kommen animiert dazu
     (is-buy), sobald der eigentliche Warenkorb-Button darunter verschwindet.
     Ohne Zurueck-Link (Breadcrumbs als Fallback) erscheint alles zusammen.
   - Der Button loest den eigentlichen Warenkorb-Button aus - Variante,
     Menge und Warenkorb-Drawer bleiben so genau wie dort. Ist dort noch
     keine Variante gewaehlt (Button gesperrt), scrollt er zum Formular.
   - Preis, Button-Text, gesperrt und Ladezustand werden von dort gespiegelt
     (Variantenwechsel, MwSt.-Umschalter).
   - Anzahl: gekoppelt mit der Mengenauswahl der Seite, in beide Richtungen.
     Deren Plus/Minus (component-quantity-selector.js) setzt den Wert ohne
     Event - deshalb wird nach Klicks dort nachgelesen und beim Setzen von
     hier auch deren gesperrt-Zustand nachgezogen.
   - Zurueck (Link oben und Button in der Leiste): kam man von genau dieser
     Kollektion, geht es zur vorigen Adresse samt gesetzten Filtern.
   - is-direct: nicht aus dem Konfigurator gekommen (weder Referrer noch
     Kollektion im Pfad) - mobil zeigt die Leiste dann "Falsche Groesse?"
     statt "Zurueck", am Desktop heisst der Button "x weitere Varianten
     ansehen". Mobil gibt es keinen Warenkorb-Teil; ohne Zurueck-Ziel
     bleibt die Leiste dort ganz weg.
   ========================================================================== */

(() => {
  if (customElements.get('l4-sticky-atc')) return;

  class L4StickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      /* Fixed-Elemente brechen, wenn ein Vorfahre transformiert ist -
         deshalb direkt an den body haengen */
      if (this.parentElement !== document.body) {
        document.body.appendChild(this);
      }

      const sectionId = this.dataset.sectionId;
      const section = document.getElementById(`shopify-section-${sectionId}`);
      this.mainButton = document.querySelector(`#add-to-cart-${sectionId} [data-main-product-add-to-cart]`);
      if (!section || !this.mainButton) return;

      this.priceSource =
        section.querySelector('[data-js-product-price-extended] [data-js-product-price-original]') ||
        section.querySelector('[data-js-product-price-compact] [data-js-product-price-original]');

      this.button = this.querySelector('[data-l4-sticky-button]');
      this.buttonText = this.querySelector('[data-l4-sticky-button-text]');
      this.prices = this.querySelectorAll('[data-l4-sticky-price]');
      this.buy = this.querySelector('[data-l4-sticky-buy]');

      this._bindBack();
      this._bindButton();
      this._bindQuantity(section);
      this._mirror();
      this._bindVisibility();
    }

    _bindBack() {
      const back = this.querySelector('[data-l4-back]');
      if (back) {
        const target = new URL(back.href, window.location.origin).pathname;
        let fromTarget = window.location.pathname.startsWith(`${target}/products/`);
        try {
          const from = document.referrer && new URL(document.referrer);
          if (from && from.origin === window.location.origin && from.pathname === target) fromTarget = true;
        } catch (e) {
          /* ungueltige Referrer-Adresse */
        }
        /* Nur wenn es die Direkteinstieg-Variante gibt (Konfigurator mit
           weiteren Produkten) - sonst bliebe mobil eine leere Leiste */
        const hasDirect = !!this.querySelector('.l4-sticky-atc__alt');
        this.classList.toggle('is-direct', hasDirect && !fromTarget);
      }

      if (!document.referrer) return;
      let from;
      try {
        from = new URL(document.referrer);
      } catch (e) {
        return; /* ungueltige Referrer-Adresse - Standardziel behalten */
      }
      if (from.origin !== window.location.origin) return;

      document.querySelectorAll('a[data-l4-back]').forEach((back) => {
        const target = new URL(back.href, window.location.origin);
        if (from.pathname === target.pathname) back.href = from.href;
      });
    }

    _bindButton() {
      this.button.addEventListener('click', () => {
        if (this.mainButton.classList.contains('disabled')) {
          const form = this.mainButton.closest('product-form') || this.mainButton;
          form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        this.mainButton.click();
      });
    }

    _bindQuantity(section) {
      const box = this.querySelector('[data-l4-sticky-qty]');
      const mainQty = section.querySelector('product-quantity');
      const mainInput = mainQty && mainQty.querySelector('.qty-selector');
      if (!box || !mainInput) return;

      const input = box.querySelector('[data-l4-qty-input]');
      const min = parseInt(mainInput.getAttribute('min'), 10) || 1;
      const max = parseInt(mainInput.getAttribute('max'), 10) || 999;
      input.min = min;
      input.max = max;
      box.hidden = false;

      const clamp = (v) => Math.min(max, Math.max(min, Number.isFinite(v) ? v : min));

      const fromMain = () => {
        input.value = clamp(parseInt(mainInput.value, 10));
      };

      const toMain = (v) => {
        const value = clamp(v);
        input.value = value;
        mainInput.value = value;
        mainQty.querySelector('.qty-minus')?.classList.toggle('disabled', value - 1 < min);
        mainQty.querySelector('.qty-plus')?.classList.toggle('disabled', value + 1 > max);
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      };

      box.addEventListener('click', (event) => {
        const step = event.target.closest('[data-l4-qty-step]');
        if (!step) return;
        toMain((parseInt(input.value, 10) || min) + parseInt(step.dataset.l4QtyStep, 10));
      });
      input.addEventListener('change', () => toMain(parseInt(input.value, 10)));

      mainInput.addEventListener('input', fromMain);
      mainInput.addEventListener('change', fromMain);
      /* Plus/Minus der Seite setzen den Wert ohne Event - danach nachlesen */
      mainQty.addEventListener('click', () => setTimeout(fromMain, 0));

      this._syncQuantity = fromMain;
      fromMain();
    }

    _mirror() {
      const sync = () => {
        if (this.priceSource) {
          this.prices.forEach((el) => (el.innerHTML = this.priceSource.innerHTML));
        }
        const text = this.mainButton.querySelector('[data-js-product-add-to-cart-text]');
        if (text) this.buttonText.textContent = text.textContent.trim();
        this.button.classList.toggle('is-disabled', this.mainButton.classList.contains('disabled'));
        this.button.classList.toggle('is-working', this.mainButton.classList.contains('working'));
      };

      const observer = new MutationObserver(sync);
      observer.observe(this.mainButton, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true, characterData: true });
      if (this.priceSource) {
        observer.observe(this.priceSource, { childList: true, subtree: true, characterData: true });
      }
      sync();
    }

    _bindVisibility() {
      let raf = 0;
      let visible = null;
      let buy = null;

      /* Oben gibt es zwei Zurueck-Links (mobil/desktop), sichtbar ist einer */
      const backLinks = Array.from(document.querySelectorAll('[data-l4-back-link]'));
      /* Mobil gibt es nur Zurueck bzw. "Falsche Groesse?" - ohne Ziel nichts */
      const mobile = window.matchMedia('(max-width: 767px)');
      const hasBack = !!this.querySelector('[data-l4-back]');

      const headerBottom = () => {
        const header = document.querySelector('.site-header');
        if (!header) return 0;
        const pos = window.getComputedStyle(header).position;
        if (pos !== 'fixed' && pos !== 'sticky') return 0;
        return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      };

      const setVisible = (on) => {
        if (on === visible) return;
        visible = on;
        if (on && this._syncQuantity) this._syncQuantity();
        this.classList.toggle('is-visible', on);
        this.toggleAttribute('inert', !on);
        this.setAttribute('aria-hidden', on ? 'false' : 'true');
      };

      const setBuy = (on) => {
        if (on === buy) return;
        buy = on;
        this.classList.toggle('is-buy', on);
        if (this.buy) this.buy.toggleAttribute('inert', !on);
      };

      /* Komplett unter dem Header verschwunden */
      const passed = (el, top) => {
        const rect = el.getBoundingClientRect();
        return rect.height > 0 && rect.bottom <= top;
      };

      const update = () => {
        raf = 0;
        const top = headerBottom();
        this.style.setProperty('--l4-sticky-top', `${top}px`);

        const buyOn = passed(this.mainButton, top);
        const backLink = backLinks.find((el) => el.offsetParent !== null);
        let barOn = backLink ? passed(backLink, top) || buyOn : buyOn;
        if (mobile.matches && !hasBack) barOn = false;

        setBuy(buyOn);
        setVisible(barOn);
      };

      const schedule = () => {
        if (!raf) raf = window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
    }
  }

  customElements.define('l4-sticky-atc', L4StickyAtc);
})();
